import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

// One-time "Congratulations, you earned a Top Badge!" shown on the winner's next login.
// Pending flag is set server-side at award time and cleared by /top-badge/congrats/ack — never shows twice.
export default function TopBadgeCongrats() {
  const { user, refresh } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  useEffect(() => { if (user?.top_badge_congrats_pending) setOpen(true); }, [user?.top_badge_congrats_pending]);

  const dismiss = async (goProfile) => {
    setOpen(false);
    try { await api.post("/top-badge/congrats/ack"); refresh?.(); } catch { /* stays pending → shows again next login */ }
    if (goProfile && user?.id) navigate(`/u/${user.id}`);
  };

  if (!open) return null;
  return (
    <div data-testid="top-badge-congrats" className="fixed inset-0 z-[120] grid place-items-center p-4 bg-black/80 backdrop-blur-md" onClick={() => dismiss(false)}>
      <div className="relative w-full max-w-sm border border-yellow-400/40 bg-zinc-950 p-8 text-center overflow-hidden" onClick={(e) => e.stopPropagation()}>
        <div className="absolute -inset-x-20 -top-32 h-64 bg-gradient-to-b from-yellow-400 to-amber-700 opacity-25 blur-3xl pointer-events-none" />
        <button data-testid="top-badge-congrats-close" onClick={() => dismiss(false)} className="absolute top-3 right-3 w-9 h-9 grid place-items-center text-zinc-500 hover:text-white" aria-label="Close"><X size={18} /></button>
        <img src="/vip-art/top_badge.png" alt="Top Badge" className="relative mx-auto w-40 h-40 object-contain drop-shadow-[0_8px_30px_rgba(250,204,21,0.45)]" draggable={false} />
        <div className="relative mt-6 text-[10px] uppercase tracking-[0.35em] text-yellow-300">Top Badge Kickoff</div>
        <h2 data-testid="top-badge-congrats-title" className="relative font-display text-3xl mt-2 text-white">Congratulations, you earned a Top Badge!</h2>
        <p className="relative text-xs text-zinc-400 mt-4 leading-relaxed">Members voted you into the top 5. Your gold Top Badge now shows on your profile and beside your name across MyPandaX.</p>
        <div className="relative mt-6 flex gap-2 justify-center">
          <Button onClick={() => dismiss(true)} className="bg-yellow-400 text-black hover:bg-yellow-300" data-testid="top-badge-congrats-profile">See it on my profile</Button>
          <Button variant="ghost" onClick={() => dismiss(false)} data-testid="top-badge-congrats-dismiss">Later</Button>
        </div>
      </div>
    </div>
  );
}
